module.exports = __webpack_public_path__ + "pc/img/main-work-img-03.1713b537.png";